import gql from 'graphql-tag';

// GET ALL OCCUPATION
export const get = gql`
  query getAllOccupationList {
    getAllOccupationList {
      code
      status
      data {
        id
        name
        description
      }
    }
  }
`;
export const save = gql`
  mutation saveOccupation($input: OccupationDtoInput) {
    saveOccupation(occupationDto: $input) {
      code
      status
      data {
        id
        name
        code
        description
        createdAt
        deleted
      }
    }
  }
`;
